import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;
const BOWER_LOGO = "https://customer-assets.emergentagent.com/job_9905ee30-c002-464f-b890-465ab6cc70dc/artifacts/9497g015_Bower%20School%20Logo-01.png";

// Reuse Indian States/Cities data
const INDIAN_STATES_CITIES = {
  "Andhra Pradesh": ["Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Kurnool", "Tirupati", "Rajahmundry", "Kakinada", "Kadapa", "Anantapur"],
  "Arunachal Pradesh": ["Itanagar", "Naharlagun", "Pasighat", "Tawang", "Ziro"],
  "Assam": ["Guwahati", "Silchar", "Dibrugarh", "Jorhat", "Nagaon", "Tinsukia", "Tezpur"],
  "Bihar": ["Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Purnia", "Darbhanga"],
  "Chhattisgarh": ["Raipur", "Bhilai", "Bilaspur", "Korba", "Durg"],
  "Goa": ["Panaji", "Margao", "Vasco da Gama", "Mapusa"],
  "Gujarat": ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar", "Jamnagar", "Gandhinagar"],
  "Haryana": ["Gurugram", "Faridabad", "Panipat", "Ambala", "Rohtak", "Hisar", "Karnal", "Sonipat"],
  "Himachal Pradesh": ["Shimla", "Dharamshala", "Solan", "Mandi", "Kullu", "Manali"],
  "Jharkhand": ["Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Hazaribagh"],
  "Karnataka": ["Bengaluru", "Mysuru", "Mangaluru", "Hubli", "Belgaum"],
  "Kerala": ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur", "Kollam"],
  "Madhya Pradesh": ["Bhopal", "Indore", "Jabalpur", "Gwalior", "Ujjain"],
  "Maharashtra": ["Mumbai", "Pune", "Nagpur", "Thane", "Nashik", "Aurangabad", "Navi Mumbai"],
  "Manipur": ["Imphal", "Thoubal", "Bishnupur"],
  "Meghalaya": ["Shillong", "Tura", "Jowai"],
  "Mizoram": ["Aizawl", "Lunglei"],
  "Nagaland": ["Kohima", "Dimapur", "Mokokchung"],
  "Odisha": ["Bhubaneswar", "Cuttack", "Rourkela", "Berhampur", "Sambalpur"],
  "Punjab": ["Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda", "Mohali"],
  "Rajasthan": ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Bikaner", "Ajmer"],
  "Sikkim": ["Gangtok", "Namchi"],
  "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem"],
  "Telangana": ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Khammam"],
  "Tripura": ["Agartala", "Udaipur"],
  "Uttar Pradesh": ["Lucknow", "Kanpur", "Agra", "Varanasi", "Meerut", "Prayagraj", "Ghaziabad", "Noida"],
  "Uttarakhand": ["Dehradun", "Haridwar", "Roorkee", "Haldwani", "Rishikesh"],
  "West Bengal": ["Kolkata", "Howrah", "Durgapur", "Asansol", "Siliguri"],
  "Delhi": ["New Delhi", "Central Delhi", "South Delhi", "North Delhi", "East Delhi", "West Delhi", "Dwarka"],
  "Chandigarh": ["Chandigarh"],
  "Puducherry": ["Puducherry", "Karaikal"],
  "Jammu and Kashmir": ["Srinagar", "Jammu", "Anantnag", "Baramulla"],
  "Ladakh": ["Leh", "Kargil"]
};
const INDIAN_STATES = Object.keys(INDIAN_STATES_CITIES).sort();

// Sales Department auto-logic
const getSalesDepartment = (category) => {
  if (!category || category === "-Select-") return "-Select-";
  const seedCategories = [
    "K\u201312 Student (Grades 3\u201310)",
    "Parent of a Teenager (Child aged 13\u201318)"
  ];
  const buildCategories = [
    "Currently Studying in Grade 11 or 12",
    "Undergraduate Aspirant (Completed or completing Grade 12)"
  ];
  const leadCategories = [
    "Undergraduate Student",
    "Graduate / Post-Graduate",
    "Working Professional / Executive",
    "Entrepreneur / Aspiring Entrepreneur"
  ];
  if (seedCategories.includes(category)) return "SEED - K12 (B2C)";
  if (buildCategories.includes(category)) return "BUILD - UG";
  if (leadCategories.includes(category)) return "LEAD - Executive";
  return "-Select-";
};

const CATEGORY_OPTIONS = [
  { value: "-Select-", label: "-Select-" },
  { value: "K\u201312 Student (Grades 3\u201310)", label: "K\u201312 Student (Grades 3\u201310)" },
  { value: "Currently Studying in Grade 11 or 12", label: "Currently Studying in Grade 11 or 12" },
  { value: "Undergraduate Aspirant (Completed or completing Grade 12)", label: "Undergraduate Aspirant (Completed or completing Grade 12)" },
  { value: "Undergraduate Student", label: "Undergraduate Student" },
  { value: "Parent of a Teenager (Child aged 13\u201318)", label: "Parent of a Teenager (Child aged 13\u201318)" },
  { value: "Graduate / Post-Graduate", label: "Graduate / Post-Graduate" },
  { value: "Working Professional / Executive", label: "Working Professional / Executive" },
  { value: "Entrepreneur / Aspiring Entrepreneur", label: "Entrepreneur / Aspiring Entrepreneur" },
];

// Speaker placeholder images
const SPEAKER_IMAGES = [
  "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face",
];

// Event Registration Form
const EventRegistrationForm = ({ eventTitle }) => {
  const [formData, setFormData] = useState({
    firstName: "", lastName: "", phone: "", email: "",
    state: "", city: "", category: "-Select-",
  });
  const [availableCities, setAvailableCities] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const formContainerRef = useRef(null);
  const iframeRef = useRef(null);

  useEffect(() => {
    if (formData.state && INDIAN_STATES_CITIES[formData.state]) {
      setAvailableCities(INDIAN_STATES_CITIES[formData.state]);
    } else {
      setAvailableCities([]);
    }
  }, [formData.state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "state") {
      setFormData(prev => ({ ...prev, state: value, city: "" }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const salesDepartment = getSalesDepartment(formData.category);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.firstName || !formData.phone || !formData.email || formData.category === "-Select-") return;
    setIsSubmitting(true);

    const getUTMValue = (paramName) => {
      if (typeof window !== "undefined" && window.zfutm_zfLead) {
        return window.zfutm_zfLead.zfutm_gC(paramName) || "";
      }
      return "";
    };

    const fields = {
      Name_First: formData.firstName,
      Name_Last: formData.lastName,
      PhoneNumber_countrycodeval: "+91",
      PhoneNumber_countrycode: formData.phone,
      Email: formData.email,
      Address_Region: formData.state,
      Address_City: formData.city,
      Radio: formData.category,
      Dropdown: salesDepartment,
      SingleLine: eventTitle || "",
      zf_referrer_name: "",
      zf_redirect_url: "",
      zc_gad: "",
      utm_source: getUTMValue("utm_source"),
      utm_medium: getUTMValue("utm_medium"),
      utm_campaign: getUTMValue("utm_campaign"),
      utm_term: getUTMValue("utm_term"),
      utm_content: getUTMValue("utm_content"),
    };

    // Build and submit a hidden form targeting the iframe
    const form = document.createElement("form");
    form.method = "POST";
    form.action = "https://forms.zohopublic.in/bowereducationalservicespriv1/form/DialogueswithBowerRSVP/formperma/Vbw5xc4UkgjzbWQNbyATrSNt_Wykw4ZuskO0700TpWo/htmlRecords/submit";
    form.target = "zoho_event_frame";
    form.enctype = "multipart/form-data";
    form.acceptCharset = "UTF-8";
    form.style.display = "none";

    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);

    // Listen for iframe load (indicates Zoho received the submission)
    const onIframeLoad = () => {
      // Cleanup: remove the form and iframe listener
      if (form.parentNode) form.parentNode.removeChild(form);
      if (iframeRef.current) iframeRef.current.removeEventListener("load", onIframeLoad);
      setIsSubmitting(false);
      setIsSubmitted(true);
      // Scroll to success message on mobile
      setTimeout(() => {
        if (formContainerRef.current) {
          formContainerRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 100);
      if (typeof window !== "undefined" && window.fbq) {
        window.fbq("track", "Lead", { content_name: "Event Registration", content_category: "Events" });
      }
    };

    if (iframeRef.current) {
      iframeRef.current.addEventListener("load", onIframeLoad);
    }

    form.submit();

    // Fallback: if iframe load doesn't fire within 5s, still show success and cleanup
    setTimeout(() => {
      if (!isSubmitted) {
        if (form.parentNode) form.parentNode.removeChild(form);
        if (iframeRef.current) iframeRef.current.removeEventListener("load", onIframeLoad);
        setIsSubmitting(false);
        setIsSubmitted(true);
        setTimeout(() => {
          if (formContainerRef.current) {
            formContainerRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 100);
        if (typeof window !== "undefined" && window.fbq) {
          window.fbq("track", "Lead", { content_name: "Event Registration", content_category: "Events" });
        }
      }
    }, 5000);
  };

  if (isSubmitted) {
    return (
      <div ref={formContainerRef} className="text-center py-10" data-testid="event-form-success">
        <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ background: "rgba(34,197,94,0.15)" }}>
          <span className="material-symbols-outlined text-3xl" style={{ color: "#22c55e" }}>check_circle</span>
        </div>
        <h3 className="text-xl font-bold text-white mb-2">Registration Successful!</h3>
        <p className="text-sm" style={{ color: "#c5c5d6" }}>We'll reach out with event details shortly.</p>
      </div>
    );
  }

  const inputStyle = { background: "#09092d", border: "none", borderRadius: "0.75rem", padding: "0.75rem 1rem", color: "#e1dfff", outline: "none", width: "100%", fontFamily: "'Plus Jakarta Sans', sans-serif" };
  const selectStyle = { ...inputStyle, appearance: "none", cursor: "pointer", WebkitAppearance: "none" };
  const labelStyle = { fontSize: "0.7rem", fontWeight: "700", textTransform: "uppercase", letterSpacing: "0.05em", color: "#c5c5d6", marginLeft: "0.25rem", marginBottom: "0.375rem", display: "block" };

  return (
    <div ref={formContainerRef}>
      <iframe ref={iframeRef} name="zoho_event_frame" style={{ display: "none" }} title="Event Form Submit" />
      <form onSubmit={handleSubmit} className="space-y-4" data-testid="event-registration-form">
        {/* Full Name */}
        <div>
          <label style={labelStyle}>Full Name <span style={{ color: "#ffb68f" }}>*</span></label>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <input name="firstName" value={formData.firstName} onChange={handleChange} placeholder="First Name" required style={inputStyle} data-testid="event-input-first-name" />
            <input name="lastName" value={formData.lastName} onChange={handleChange} placeholder="Last Name" style={inputStyle} data-testid="event-input-last-name" />
          </div>
        </div>

        {/* Phone */}
        <div>
          <label style={labelStyle}>Phone <span style={{ color: "#ffb68f" }}>*</span></label>
          <div className="flex gap-2 md:gap-3">
            <div className="flex items-center gap-1.5 md:gap-2 rounded-xl px-3 md:px-4 py-3 shrink-0" style={{ background: "#09092d", color: "#e1dfff", minWidth: "80px" }}>
              <span className="text-base md:text-lg">{"\ud83c\uddee\ud83c\uddf3"}</span>
              <span className="font-medium text-sm md:text-base">+91</span>
            </div>
            <input name="phone" value={formData.phone} onChange={handleChange} placeholder="10-digit mobile number" required maxLength={10} style={inputStyle} data-testid="event-input-phone" />
          </div>
        </div>

        {/* Email */}
        <div>
          <label style={labelStyle}>Email Address <span style={{ color: "#ffb68f" }}>*</span></label>
          <input name="email" type="email" value={formData.email} onChange={handleChange} placeholder="john@example.com" required style={inputStyle} data-testid="event-input-email" />
        </div>

        {/* Address - State & City as native select dropdowns */}
        <div>
          <label style={labelStyle}>Address</label>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <select
              name="state"
              value={formData.state}
              onChange={handleChange}
              style={selectStyle}
              data-testid="event-select-state"
            >
              <option value="">State/Region</option>
              {INDIAN_STATES.map(state => (
                <option key={state} value={state}>{state}</option>
              ))}
            </select>
            <select
              name="city"
              value={formData.city}
              onChange={handleChange}
              disabled={!formData.state}
              style={{ ...selectStyle, opacity: formData.state ? 1 : 0.5 }}
              data-testid="event-select-city"
            >
              <option value="">{formData.state ? "City" : "Select state first"}</option>
              {availableCities.map(city => (
                <option key={city} value={city}>{city}</option>
              ))}
            </select>
          </div>
        </div>

        {/* Category */}
        <div>
          <label style={labelStyle}>Category <span style={{ color: "#ffb68f" }}>*</span></label>
          <select
            name="category"
            value={formData.category}
            onChange={handleChange}
            required
            style={selectStyle}
            data-testid="event-select-category"
          >
            {CATEGORY_OPTIONS.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>

        {/* Hidden Sales Department - auto-computed */}
        <input type="hidden" name="salesDepartment" value={salesDepartment} />

        {/* Submit */}
        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full py-3.5 md:py-4 rounded-xl text-white font-bold text-base flex items-center justify-center gap-2 transition-all active:scale-95"
          style={{ background: "#2F4DC5" }}
          data-testid="event-form-submit-btn"
        >
          {isSubmitting ? (
            <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
          ) : (
            <>
              <em>Register Now</em>
              <span className="material-symbols-outlined">arrow_forward</span>
            </>
          )}
        </button>
      </form>

      <div className="mt-6 pt-4 flex items-center justify-between text-xs" style={{ borderTop: "1px solid rgba(68,70,84,0.1)", color: "#c5c5d6" }}>
        <span className="flex items-center gap-1">
          <span className="material-symbols-outlined text-[14px]">lock</span> Secure Registration
        </span>
        <span className="flex items-center gap-1 font-bold" style={{ color: "#ffb68f" }}>
          <span className="material-symbols-outlined text-[14px]">stars</span> Limited Spots
        </span>
      </div>
    </div>
  );
};


const EventDetailPage = () => {
  const { id } = useParams();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/events/${id}`);
        setEvent(res.data);
      } catch (err) {
        console.error("Failed to fetch event:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchEvent();
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "#0f0f32" }}>
        <div className="w-8 h-8 border-2 border-[#b9c3ff] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!event) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "#0f0f32", color: "#e1dfff" }}>
        <div className="text-center">
          <span className="material-symbols-outlined text-5xl mb-4 block" style={{ color: "#444654" }}>error</span>
          <h2 className="text-2xl font-bold mb-2">Event not found</h2>
          <Link to="/events" className="text-[#b9c3ff] hover:underline">Back to Events</Link>
        </div>
      </div>
    );
  }

  const getSpeakerImage = (speaker, index) => {
    if (speaker.image) return speaker.image;
    return SPEAKER_IMAGES[index % SPEAKER_IMAGES.length];
  };

  return (
    <div className="min-h-screen" style={{ background: "#0f0f32", color: "#c5c5d6", fontFamily: "'Plus Jakarta Sans', sans-serif" }} data-testid="event-detail-page">
      {/* Nav */}
      <nav className="fixed top-0 w-full z-50" style={{ background: "linear-gradient(to bottom, #0f0f32, transparent)", backdropFilter: "blur(20px)" }}>
        <div className="flex justify-between items-center max-w-7xl mx-auto px-4 md:px-8 py-4">
          <div className="flex items-center gap-4">
            <Link to="/" data-testid="detail-logo-link">
              <img src={BOWER_LOGO} alt="Bower School" className="h-12 md:h-14 object-contain brightness-0 invert" />
            </Link>
          </div>
          <div className="hidden md:flex gap-8 items-center">
            <Link to="/events" className="font-bold tracking-tight text-sm pb-1 border-b-2" style={{ color: "#b9c3ff", borderColor: "#2F4DC5" }}>Events</Link>
            <a className="font-bold tracking-tight text-sm hover:text-white transition-colors" style={{ color: "#c5c5d6" }} href="#">Programs</a>
            <a className="font-bold tracking-tight text-sm hover:text-white transition-colors" style={{ color: "#c5c5d6" }} href="#">About</a>
            <a className="font-bold tracking-tight text-sm hover:text-white transition-colors" style={{ color: "#c5c5d6" }} href="#">Admissions</a>
          </div>
          <button className="px-4 md:px-6 py-2 md:py-2.5 rounded-full font-bold text-xs md:text-sm transition-all shadow-lg whitespace-nowrap" style={{ background: "linear-gradient(135deg, #b9c3ff, #2f4dc5)", color: "#001356" }} onClick={() => document.getElementById("event-form")?.scrollIntoView({ behavior: "smooth" })}>
            Register Now
          </button>
        </div>
      </nav>

      <main className="relative pt-20 md:pt-32 pb-24 overflow-x-hidden">
        {/* Decorative glows - hidden on mobile to prevent overflow */}
        <div className="absolute top-0 right-0 -z-10 w-[300px] md:w-[600px] h-[300px] md:h-[600px] rounded-full blur-[120px] translate-x-1/3 md:translate-x-1/2 -translate-y-1/2" style={{ background: "rgba(47,77,197,0.1)" }} />

        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid lg:grid-cols-12 gap-6 lg:gap-16 items-start">
            {/* Mobile: Form first, Desktop: Event info first */}
            {/* Right: Sticky Form (appears first on mobile via order) */}
            <div className="lg:col-span-5 lg:sticky lg:top-32 order-first lg:order-last min-w-0" id="event-form">
              <div className="p-5 md:p-8 rounded-2xl md:rounded-[2rem] shadow-2xl" style={{ background: "rgba(38,38,74,0.4)", backdropFilter: "blur(12px)", border: "1px solid rgba(68,70,84,0.2)" }}>
                <div className="mb-5 md:mb-8">
                  <h3 className="text-lg md:text-2xl font-bold mb-1 md:mb-2" style={{ color: "#e1dfff" }}>Register for this Event</h3>
                  <p className="text-xs md:text-sm" style={{ color: "#c5c5d6" }}>
                    {event.spots_left > 0 ? `Limited to ${event.spots_left} participants for personalized mentorship.` : "Registration is open."}
                  </p>
                </div>
                <EventRegistrationForm eventTitle={event.title} />
              </div>
            </div>

            {/* Left: Event Info (appears second on mobile via order) */}
            <div className="lg:col-span-7 order-last lg:order-first min-w-0">
              {/* Series Tag */}
              {event.series_tag && (
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold tracking-widest uppercase mb-4 md:mb-8" style={{ background: "#26264a", border: "1px solid rgba(68,70,84,0.15)", color: "#b9c3ff" }}>
                  <span className="w-2 h-2 rounded-full animate-pulse" style={{ background: "#ffb68f" }} />
                  {event.series_tag}
                </div>
              )}

              <h1 className="font-extrabold text-3xl sm:text-4xl md:text-5xl lg:text-7xl leading-[1.1] tracking-tight mb-4 md:mb-6" style={{ color: "#e1dfff" }} data-testid="event-detail-title">
                {event.title.split(" ").slice(0, -1).join(" ")}{" "}
                <span className="bg-clip-text text-transparent" style={{ backgroundImage: "linear-gradient(to right, #b9c3ff, #ffb68f)" }}>
                  {event.title.split(" ").slice(-1)}
                </span>
              </h1>

              {/* Banner Image */}
              {event.banner_image && (
                <div className="mb-6 md:mb-10 rounded-xl md:rounded-2xl overflow-hidden shadow-2xl" style={{ border: "1px solid rgba(68,70,84,0.2)" }}>
                  <img src={event.banner_image} alt="Event Banner" className="w-full h-auto object-cover" />
                </div>
              )}

              <p className="text-sm md:text-xl max-w-full mb-8 md:mb-12 leading-relaxed break-words" style={{ color: "#c5c5d6" }} data-testid="event-detail-description">
                {event.description}
              </p>

              {/* Info Tags */}
              <div className="grid grid-cols-2 gap-3 md:gap-8 mb-10 md:mb-16">
                {[
                  { icon: "calendar_today", label: "Date", value: event.date },
                  { icon: "schedule", label: "Time", value: event.time },
                  { icon: "location_on", label: "Location", value: event.location },
                  { icon: "groups", label: "Audience", value: event.audience_tag || event.audience },
                ].map((item, i) => (
                  <div key={i} className="flex items-start gap-2 md:gap-4 min-w-0">
                    <div className="w-9 h-9 md:w-12 md:h-12 rounded-xl flex items-center justify-center shrink-0" style={{ background: "#26264a", color: "#b9c3ff" }}>
                      <span className="material-symbols-outlined text-[18px] md:text-[24px]">{item.icon}</span>
                    </div>
                    <div className="min-w-0 overflow-hidden">
                      <h4 className="font-bold text-xs md:text-base" style={{ color: "#e1dfff" }}>{item.label}</h4>
                      <p className="text-xs md:text-sm truncate" style={{ color: "#c5c5d6" }}>{item.value || "TBD"}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* About the Event */}
              <div className="space-y-12 md:space-y-24">
                {event.about && (
                  <section>
                    <h2 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6" style={{ color: "#e1dfff" }}>About the Event</h2>
                    <div className="h-1 w-20 rounded-full mb-6 md:mb-8" style={{ background: "#b9c3ff" }} />
                    <div
                      className="event-about-content text-base md:text-lg leading-loose prose prose-invert max-w-none"
                      style={{ color: "#c5c5d6" }}
                      dangerouslySetInnerHTML={{ __html: event.about }}
                    />
                  </section>
                )}

                {/* What You Will Experience */}
                {event.experiences && event.experiences.length > 0 && (
                  <section className="p-5 md:p-10 rounded-2xl md:rounded-[2rem]" style={{ background: "#17173b", border: "1px solid rgba(68,70,84,0.1)" }}>
                    <h2 className="text-2xl md:text-3xl font-bold mb-6 md:mb-10" style={{ color: "#e1dfff" }}>What You Will Experience</h2>
                    <div className="grid gap-5 md:gap-6">
                      {event.experiences.map((exp, i) => (
                        <div key={i} className="flex items-start gap-4 group">
                          <span className="material-symbols-outlined mt-1 group-hover:scale-125 transition-transform" style={{ color: "#ffb68f" }}>{exp.icon}</span>
                          <div>
                            <h4 className="font-bold mb-1" style={{ color: "#e1dfff" }}>{exp.title}</h4>
                            <p className="text-sm">{exp.description}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </section>
                )}
              </div>
            </div>

          </div>
        </div>
      </main>

      {/* Speakers Section */}
      {event.speakers && event.speakers.length > 0 && (
        <section className="py-12 md:py-24" style={{ background: "#09092d" }}>
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 md:mb-16 gap-4 md:gap-8">
              <div>
                <h2 className="text-2xl md:text-4xl font-bold mb-2 md:mb-4" style={{ color: "#e1dfff" }}>Speakers & Mentors</h2>
                <p className="text-sm md:text-base max-w-lg" style={{ color: "#c5c5d6" }}>Learn from the architects of today's most successful startups and venture firms.</p>
              </div>
              <div className="hidden md:flex gap-4">
                <button className="w-12 h-12 rounded-full flex items-center justify-center transition-colors" style={{ border: "1px solid rgba(68,70,84,0.3)" }}>
                  <span className="material-symbols-outlined" style={{ color: "#e1dfff" }}>arrow_back</span>
                </button>
                <button className="w-12 h-12 rounded-full flex items-center justify-center transition-colors" style={{ border: "1px solid rgba(68,70,84,0.3)" }}>
                  <span className="material-symbols-outlined" style={{ color: "#e1dfff" }}>arrow_forward</span>
                </button>
              </div>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-8" data-testid="speakers-grid">
              {event.speakers.map((speaker, i) => (
                <div key={i} className="group cursor-pointer" data-testid={`speaker-card-${i}`}>
                  <div className="relative rounded-xl md:rounded-[2rem] overflow-hidden mb-3 md:mb-6 aspect-square">
                    <img
                      src={getSpeakerImage(speaker, i)}
                      alt={speaker.name}
                      className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-500"
                    />
                    <div className="absolute inset-0 opacity-60" style={{ background: "linear-gradient(to top, #0f0f32, transparent)" }} />
                    {speaker.linkedin && (
                      <a href={speaker.linkedin} target="_blank" rel="noopener noreferrer" className="absolute bottom-4 right-4 z-20 p-2 rounded-full text-white hover:scale-110 transition-transform shadow-lg flex items-center justify-center" style={{ background: "rgba(0,0,0,0.4)", backdropFilter: "blur(8px)", border: "1px solid rgba(255,255,255,0.2)" }}>
                        <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" /></svg>
                      </a>
                    )}
                  </div>
                  <h4 className="text-sm md:text-xl font-bold" style={{ color: "#e1dfff" }}>{speaker.name}</h4>
                  <p className="text-xs md:text-sm font-medium tracking-wide" style={{ color: "#ffb68f" }}>{speaker.title}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* CTA Banner */}
      <section className="py-12 md:py-24">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="relative rounded-2xl md:rounded-[3rem] p-8 md:p-24 overflow-hidden text-center" style={{ background: "linear-gradient(to bottom right, #2f4dc5, #0f0f32)", border: "1px solid rgba(185,195,255,0.2)" }}>
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full" style={{ background: "radial-gradient(circle at center, rgba(47,77,197,0.15) 0%, transparent 70%)" }} />
            <h2 className="text-2xl sm:text-3xl md:text-6xl font-black mb-4 md:mb-8 relative z-10" style={{ color: "#e1dfff" }}>
              Be in the Room <br className="hidden md:block" />
              Where Builders Begin
            </h2>
            <p className="text-sm md:text-xl max-w-2xl mx-auto mb-6 md:mb-12 relative z-10" style={{ color: "#c5cdff" }}>
              The next cohort is forming. Step out of the sidelines and into the driver's seat of your future.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-3 md:gap-4 relative z-10">
              <button onClick={() => document.getElementById("event-form")?.scrollIntoView({ behavior: "smooth" })} className="px-8 md:px-10 py-4 md:py-5 rounded-full font-black text-base md:text-lg hover:scale-105 transition-all shadow-xl" style={{ background: "white", color: "#0f0f32" }} data-testid="cta-register-btn">
                Register Now
              </button>
              {event.brochure_url && (
                <a href={event.brochure_url} target="_blank" rel="noopener noreferrer" className="px-8 md:px-10 py-4 md:py-5 rounded-full font-bold text-base md:text-lg transition-all" style={{ background: "rgba(49,49,86,0.6)", backdropFilter: "blur(8px)", border: "1px solid rgba(68,70,84,0.3)", color: "#e1dfff" }}>
                  Download Brochure
                </a>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="w-full py-10 md:py-16 px-4 md:px-8" style={{ background: "#0a0a28", borderTop: "1px solid rgba(68,70,84,0.15)" }} data-testid="event-detail-footer">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-12">
            {/* Brand */}
            <div className="col-span-2 md:col-span-1">
              <img src={BOWER_LOGO} alt="Bower School" className="h-12 md:h-14 object-contain brightness-0 invert mb-4" />
              <p className="text-sm leading-relaxed" style={{ color: "#8e909f" }}>Building the next generation of industry disruptors.</p>
            </div>

            {/* Programs */}
            <div>
              <h4 className="text-white font-bold text-xs uppercase tracking-widest mb-5">Programs</h4>
              <nav className="flex flex-col gap-3">
                <a href="/beat" className="text-sm hover:text-white transition-colors" style={{ color: "#8e909f" }}>BEAT Test</a>
                <a href="/gitam" className="text-sm hover:text-white transition-colors" style={{ color: "#8e909f" }}>GITAM x Bower BBA</a>
                <a href="/seed" className="text-sm hover:text-white transition-colors" style={{ color: "#8e909f" }}>SEED for Schools</a>
                <a href="https://bowerschool.com/" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-white transition-colors" style={{ color: "#8e909f" }}>3-Year BBA Programme</a>
                <a href="https://bowerschool.com/" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-white transition-colors" style={{ color: "#8e909f" }}>Admissions</a>
              </nav>
            </div>

            {/* Events */}
            <div>
              <h4 className="text-white font-bold text-xs uppercase tracking-widest mb-5">Events</h4>
              <nav className="flex flex-col gap-3">
                <a href="/events" className="text-sm hover:text-white transition-colors" style={{ color: "#8e909f" }}>All Events</a>
                <a href="/admin/events" className="text-sm hover:text-white transition-colors" style={{ color: "#8e909f" }}>Manage Events</a>
              </nav>
            </div>

            {/* Company */}
            <div>
              <h4 className="text-white font-bold text-xs uppercase tracking-widest mb-5">Company</h4>
              <nav className="flex flex-col gap-3">
                <a href="https://bowerschool.com/" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-white transition-colors" style={{ color: "#8e909f" }}>Home</a>
                <a href="https://bowerschool.com/terms-of-service" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-white transition-colors" style={{ color: "#8e909f" }}>Terms of Service</a>
                <a href="https://bowerschool.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-white transition-colors" style={{ color: "#8e909f" }}>Privacy Policy</a>
                <a href="https://bowerschool.com/refund-policy" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-white transition-colors" style={{ color: "#8e909f" }}>Refund Policy</a>
              </nav>
            </div>
          </div>
          <div className="border-t pt-8 text-center text-sm" style={{ borderColor: "rgba(68,70,84,0.15)", color: "#8e909f" }}>
            &copy; 2025 Bower School of Entrepreneurship. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default EventDetailPage;
